import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getSingleSeries, getSeriesStatus, getSeriesErrors } from '@store/reducers/series/selectors';
import { editSeriesAction, getSingleSeriesAction } from '@store/actions/series';
import { getPermittedPermissions } from '@store/reducers/check-permission/selectors';
import Main from './Main';

const mapStateToProps = state => ({
  singleSeries: getSingleSeries(state),
  seriesStatus: getSeriesStatus(state),
  seriesErrors: getSeriesErrors(state),
  permittedPermissions: getPermittedPermissions(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getSingleSeriesAction,
      editSeriesAction,
    },
    dispatch,
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Main);
